<div class="d-flex">
    <div>
        <app-superadminsidenav></app-superadminsidenav>
    </div>
    <div style="
        height: 100vh;
        overflow: scroll;
        width: 100%;
        background-color: rgba(250, 250, 250, 1);
      ">
        <div style="padding-left: 10px" class="container">
            <div>
                <div class="heading-div">
                    <h2 >Nutrition Recipe</h2>
                    <!-- <span class="mandatory-text">(All fields are mandatory)</span> -->
                </div>
                <div class="grid-2-col">
                    <div>
                        <label for="name">Recipe Name</label>
                        <input type="text" name="name" class="form-control" placeholder="e.g. Aubergine stuffed" [(ngModel)]="recipeName">
                    </div>
                    <div>
                        <label for="description">Description</label>
                       <input type="text" name="description" class="form-control" placeholder="e.g. This stuffed aubergine recipe is filled with soft rice and ...." [(ngModel)]="description">
                    </div>
                    <div>
                        <label for="directions">Directions</label>   
                        <textarea name="directions" class="form-control" placeholder="e.g. Prick The Aubergines, Cut In Half And Bake, Flesh Side Down For 30 Minutes At 190°C/Mark 5. Fry The Onions...." id="" [(ngModel)]="direction"></textarea>
                    </div>
                    <div>
                        <label for="cookTime">Cooking time (in mins)</label>
                        <input type="number" name="cookTime" class="form-control" placeholder="e.g. 60" [(ngModel)]="cookingTime">
                    </div>
                    <div>
                        <label for="price">Price</label>
                        <input type="number" name="price" class="form-control" placeholder="e.g. 20" [(ngModel)]="price">
                    </div>
                    <div>
                        <label for="calories">Calories (in kcal/100g)</label>
                        <input type="text" name="calories" class="form-control" placeholder="e.g. 91kcal/100g" [(ngModel)]="calorie">
                    </div>
                </div>
                <div>
                    <div class="one-line-btn">
                        <div>
                            <label for="ingredients">Ingredients (select from list)</label>
                            <ng-select class="multi-select" [items]="allIngredient" bindLabel="sub_ingredient_name"
                                bindValue="sub_ingredient_id" [multiple]="true" groupBy="selectedAllGroup"
                                [selectableGroup]="true" placeholder="Select ingredients"
                                (change)="ingredientChangeHandeler($event)" name="Dietary"
                                [(ngModel)]="ingredientSelect">
                                <ng-template ng-optgroup-tmp let-item="item" let-item$="item$" let-index="index">

                                </ng-template>
                            </ng-select>
                        </div>
                        <div>
                            <button (click)="openIngredientDialog()" class="add-btn"><img
                                    src="../../../assets/img/add.svg" alt=""> New</button>
                        </div>
                    </div>
                    <div *ngIf="allSelectedIngredient.length > 0" class="table-div">
                        <table class="table">
                            <thead>
                                <tr>
                                    <th scope="col">Ingredient Name</th>
                                    <th scope="col">Food Code</th>
                                    <th scope="col">Type</th>
                                    <th scope="col">Quantity (with unit)</th>
                                    <th scope="col" style="text-align: center;">Delete</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let item of allSelectedIngredient;let i= index">
                                    <td scope="row">{{item.sub_ingredient_name}}</td>
                                    <td *ngIf="item.food_code">{{item.food_code}}</td>
                                    <td *ngIf="!item.food_code">
                                        <input type="text" placeholder="please enter food-code"
                                            (change)="ingredientDataHandeler('food-code', $event.target.value,i)"
                                            class="form-control">
                                    </td>
                                    <td *ngIf="item.ingredient_name">{{item.ingredient_name}}</td>
                                    <td *ngIf="!item.ingredient_name" style="min-width: 15vw;">
                                        <!-- <select name="ingri-type" id=""
                                            (change)="ingredientDataHandeler('type', $event.target.value,i)"
                                            class="form-select">
                                            <option value="" disabled selected>Select type</option>
                                            <option *ngFor="let ele of indridentApiData['ingredient_types']"
                                                value={{ele}}>{{ele.ingredient_name}}</option>
                                        </select> -->
                                        <ng-select class="multi-select" [items]="indridentApiData['ingredient_types']"
                                            bindLabel="ingredient_name" bindValue="ingredient_id" [multiple]="false"
                                            groupBy="selectedAllGroup" [selectableGroup]="true"
                                            placeholder="Select dietary preferences"
                                            (change)="ingredientDataHandeler('type', $event,i)" name="Dietary"
                                            [(ngModel)]="indredientType">
                                            <ng-template ng-optgroup-tmp let-item="item" let-item$="item$"
                                                let-index="index">

                                            </ng-template>
                                        </ng-select>
                                    </td>
                                    <td><input type="text" placeholder="please enter quantity"
                                            (change)="ingredientDataHandeler('weight', $event.target.value,i)"
                                            class="form-control"></td>
                                    <td style="text-align: center;"><img src="../../../assets/images/deletIcon.png"
                                            alt="" srcset="" class="delete-icon-img"
                                            (click)="deleteIngridentHandeler(i)"></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="grid-2-col">
                    <div class="one-line-btn">
                        <div>
                            <label for="category-name">Category name</label>
                            <ng-select class="multi-select" [items]="allCategory" bindLabel="dish_type_name"
                                bindValue="dish_type_id" [multiple]="false" groupBy="selectedAllGroup"
                                [selectableGroup]="true" placeholder="Select category name"
                                (change)="categoryChangeHandeler($event)" name="Dietary" [(ngModel)]="selectedCategory">
                                <ng-template ng-optgroup-tmp let-item="item" let-item$="item$" let-index="index">

                                </ng-template>
                            </ng-select>

                        </div>
                        <div>
                            <button (click)="openCategoryDialog()" class="add-btn"><img
                                    src="../../../assets/img/add.svg" alt=""> New</button>
                        </div>
                    </div>
                    <div class="one-line-btn">
                        <div>
                            <label for="allergens-name">Tags</label>
                            <ng-select class="multi-select" [items]="allTags" bindLabel="tag_name"
                                bindValue="tag_id" [multiple]="true" groupBy="selectedAllGroup"
                                [selectableGroup]="true" placeholder="Select tags"
                                (change)="tagsChangeHandeler($event)" name="Dietary"
                                [(ngModel)]="selectedTags">
                                <ng-template ng-optgroup-tmp let-item="item" let-item$="item$" let-index="index">

                                </ng-template>
                            </ng-select>

                        </div>
                        <div>
                            <button (click)="openTagsDialog()" class="add-btn"><img
                                    src="../../../assets/img/add.svg" alt=""> New</button>
                        </div>
                    </div>
                    <div class="one-line-btn">
                        <div>
                            <label for="allergens-name">Allergens name</label>
                            <ng-select class="multi-select" [items]="allAllergens" bindLabel="allergens_name"
                                bindValue="allergens_id" [multiple]="true" groupBy="selectedAllGroup"
                                [selectableGroup]="true" placeholder="Select allergens name"
                                (change)="allergensChangeHandeler($event)" name="Dietary"
                                [(ngModel)]="selectedAllergens">
                                <ng-template ng-optgroup-tmp let-item="item" let-item$="item$" let-index="index">

                                </ng-template>
                            </ng-select>

                        </div>
                        <div>
                            <button (click)="openAllergensDialog()" class="add-btn"><img
                                    src="../../../assets/img/add.svg" alt=""> New</button>
                        </div>
                    </div>
                    <div class="one-line-btn">
                        <div>
                            <label for="allergens-name">Allergens available option</label>
                            <ng-select class="multi-select" [items]="allAoAllergens" bindLabel="allergens_name"
                                bindValue="allergens_id" [multiple]="true" groupBy="selectedAllGroup"
                                [selectableGroup]="true" placeholder="Select allergens available option"
                                (change)="aoAllergensChangeHandeler($event)" name="Dietary"
                                [(ngModel)]="selectedAoAllergens">
                                <ng-template ng-optgroup-tmp let-item="item" let-item$="item$" let-index="index">

                                </ng-template>
                            </ng-select>

                        </div>
                        <div>
                            <button (click)="openAoAllergensDialog()" class="add-btn"><img
                                    src="../../../assets/img/add.svg" alt=""> New</button>
                        </div>
                    </div>
                    <div class="one-line-btn">
                        <div>
                            <label for="Unsuitable-dietary-preference">Unsuitable dietary preference</label>
                            <ng-select class="multi-select" [items]="allUsDietary" bindLabel="diet_preference_name"
                                bindValue="diet_preference_id" [multiple]="true" groupBy="selectedAllGroup"
                                [selectableGroup]="true" placeholder="Select unsuitable dietary preference"
                                (change)="usDietaryChangeHandeler($event)" name="Dietary"
                                [(ngModel)]="selectedUsDietary">
                                <ng-template ng-optgroup-tmp let-item="item" let-item$="item$" let-index="index">

                                </ng-template>
                            </ng-select>
                        </div>
                        <div>
                            <button (click)="openUsDietaryDialog()" class="add-btn"><img
                                    src="../../../assets/img/add.svg" alt=""> New</button>
                        </div>

                    </div>
                    <div class="one-line-btn">
                        <div>
                            <label for="suitable-dietary-preference">Suitable Dietary Preferance</label>
                            <ng-select class="multi-select" [items]="allStDietary" bindLabel="diet_preference_name"
                                bindValue="diet_preference_id" [multiple]="true" groupBy="selectedAllGroup"
                                [selectableGroup]="true" placeholder="Select suitable dietary preference"
                                (change)="stDietaryChangeHandeler($event)" name="Dietary"
                                [(ngModel)]="selectedStDietary">
                                <ng-template ng-optgroup-tmp let-item="item" let-item$="item$" let-index="index">

                                </ng-template>
                            </ng-select>

                        </div>
                        <div>
                            <button (click)="openStDietaryDialog()" class="add-btn"><img
                                    src="../../../assets/img/add.svg" alt=""> New</button>
                        </div>

                    </div>
                    <div class="one-line-btn">
                        <div>
                            <label for="available-dietary-preference">Dietry preference available option</label>
                            <ng-select class="multi-select" [items]="allAoDietary" bindLabel="diet_preference_name"
                                bindValue="diet_preference_id" [multiple]="true" groupBy="selectedAllGroup"
                                [selectableGroup]="true" placeholder="Select dietry preference available options"
                                (change)="aoDietaryChangeHandeler($event)" name="Dietary"
                                [(ngModel)]="selectedAoDietary">
                                <ng-template ng-optgroup-tmp let-item="item" let-item$="item$" let-index="index">

                                </ng-template>
                            </ng-select>

                        </div>
                        <div>
                            <button (click)="openAoDietaryDialog()" class="add-btn"><img
                                    src="../../../assets/img/add.svg" alt=""> New</button>
                        </div>
                    </div>
                </div>
                <div>
                    <div>
                        <div>
                            <label for="ingredients">Macronutrients and Micronutrients</label>
                            <ng-select class="multi-select" [items]="allMacroMicro" bindLabel="name" bindValue="id"
                                [multiple]="true" groupBy="selectedAllGroup" [selectableGroup]="true"
                                placeholder="Select macronutrients and micronutrients" (change)="macroMicroChangeHandeler($event)"
                                name="Dietary" [(ngModel)]="macroMicroSelect">
                                <ng-template ng-optgroup-tmp let-item="item" let-item$="item$" let-index="index">

                                </ng-template>
                            </ng-select>
                        </div>
                        <!-- <div>
                            <button (click)="openMacroMicroDialog()" class="add-btn"><img
                                    src="../../../assets/img/add.svg" alt=""> New</button>
                        </div> -->
                    </div>
                    <div *ngIf="allSelectedMacroMicro.length > 0" class="table-div">
                        <table class="table">
                            <thead>
                                <tr>
                                    <th scope="col">Macronutrients/Micronutrients Name</th>
                                    <th scope="col">Quantity (with unit)</th>
                                    <th scope="col" style="text-align: center;">Delete</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let item of allSelectedMacroMicro;let i= index">
                                    <td scope="row">{{item}}</td>
                                    <td><input type="text" placeholder="please enter quantity"
                                            (change)="macroMicroDataHandeler( $event.target.value,item)"
                                            class="form-control"></td>
                                    <td style="text-align: center;"><img src="../../../assets/images/deletIcon.png"
                                            alt="" srcset="" class="delete-icon-img"
                                            (click)="deleteMacroMicroHandeler(i,item)"></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>






            </div>

            <div class="dish-upload-div">
                <button class="dish-upload-btn" (click)="addRecipe()">Add Dish</button>
            </div>
        </div>
    </div>
</div>